<template>
  <div>
    <div class="lf eventCategory w326 ml  ">
      <div class="inner-wrap">
        <div class="argument-warp">
          <div class="fl" id="myChartBK" style="width:50%;height:100%;margin: 0 auto;"></div>
          <div class="fl" id="myChartPP" style="width:50%;height:100%;"></div>
        </div>
      </div>
      <div class="flex_box">
        <title-h3 :titlemsg="titlemsg4"></title-h3>
        <title-h3 titlemsg="产品数据"></title-h3>
      </div>

    </div>
  </div>
</template>


<script>
  import * as echarts from 'echarts';
  import title from '../title'
  export default {
    name: 'eventCategory',
    data() {
      return {
        titlemsg4: '商户类型',
        timer: null
      }
    },
    watch: {
      echarts() {
        //调用定时器
        this.timer();
      }
    },
    mounted() {
      this.drawLine();
      this.drawLineProgess();
    },
    methods: {
      setInter() {

        // let that = this        //  return setTimeout(() => {
        //   this.drawLine();          }, 3000)      },
    drawLine() {
      let that = this
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChartBK'));
      var dataAxis = ['服务', '商品'];
      var data = [600, 990];
      var yMax = 1000;
      var dataShadow = [];

      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      var option = {
        grid: {
          left: '12%',
          top: '10%',
          bottom: '12%',
          right: '4%'
        },
        xAxis: {
          data: dataAxis,
          axisLabel: {
            //              inside: true,
            textStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#637eaf'
            }
          },
          z: 10
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }, //去除网格线
          axisLine: {
            show: true,
            lineStyle: {
              color: '#637eaf'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [{
            name: '事件灾害',
            stack: '广告', //设置分类，同一类合并，多个series数据成一个柱
            type: 'bar',
            // color:"rgb(236,110,100)",
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(236, 166, 161)'
              },
              {
                offset: 0.5,
                color: 'rgb(236,110,100)'
              },
              {
                offset: 1,
                color: 'rgb(236,110,100)'
              }
            ]),
            barWidth: 22,
            data: [320]
          },
          {
            name: '公共卫生',
            type: 'bar',
            stack: '广告',
            data: [0, 132],
            // color:'rgb(100,189,166)',
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(146, 189, 178)'
              },
              {
                offset: 0.5,
                color: 'rgb(100,189,166)'
              },
              {
                offset: 1,
                color: 'rgb(100,189,166)'
              }
            ]),
          },
          {
            name: '自然灾害',
            type: 'bar',
            stack: '广告',
            data: [0, 0, 191, ],
            // color:'rgb(5,151,235)',
             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(126, 179, 235)'
              },
              {
                offset: 0.5,
                color: 'rgb(5,151,235)'
              },
              {
                offset: 1,
                color: 'rgb(5,151,235)'
              }
            ])
          },
          {
            name: '公共安全',
            type: 'bar',
            stack: '广告',
            data: [0, 0, 0, 154],
            // color:'rgb(218,185,50)',
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(218, 211, 106)'
              },
              {
                offset: 0.5,
                color: 'rgb(218,185,50)'
              },
              {
                offset: 1,
                color: 'rgb(218,185,50)'
              }
            ])
          },
          {
            name: '无事件分类',
            stack: '广告', //设置分类，同一类合并，多个series数据成一个柱
            type: 'bar',
            // color:"rgb(179,111,230)",
             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(205, 162, 230)'
              },
              {
                offset: 0.5,
                color: 'rgb(179,111,230)'
              },
              {
                offset: 1,
                color: 'rgb(179,111,230)'
              }
            ]),
            data: [0, 0, 0, 0, 145]
          }
        ]
      };


      myChart.setOption(option);
    },
    drawLineProgess() {
      let myChart = this.$echarts.init(document.getElementById('myChartPP'));
      var dataAxis = ['服务', '商品'];
      var data = [300, 290];
      var yMax = 1000;
      var dataShadow = [];

      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      var option = {
        grid: {
          left: '12%',
          top: '10%',
          bottom: '12%',
          right: '4%'
        },
        xAxis: {
          data: dataAxis,
          axisLabel: {
            //              inside: true,
            textStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#637eaf'
            }
          },
          z: 10
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }, //去除网格线
          axisLine: {
            show: true,
            lineStyle: {
              color: '#637eaf'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [{
            name: '事件灾害',
            stack: '广告', //设置分类，同一类合并，多个series数据成一个柱
            type: 'bar',
            // color:"rgb(236,110,100)",
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(236, 166, 161)'
              },
              {
                offset: 0.5,
                color: 'rgb(236,110,100)'
              },
              {
                offset: 1,
                color: 'rgb(236,110,100)'
              }
            ]),
            barWidth: 22,
            data: [320]
          },
          {
            name: '公共卫生',
            type: 'bar',
            stack: '广告',
            data: [0, 132],
            // color:'rgb(100,189,166)',
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(146, 189, 178)'
              },
              {
                offset: 0.5,
                color: 'rgb(100,189,166)'
              },
              {
                offset: 1,
                color: 'rgb(100,189,166)'
              }
            ]),
          },
          {
            name: '自然灾害',
            type: 'bar',
            stack: '广告',
            data: [0, 0, 191, ],
            // color:'rgb(5,151,235)',             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(126, 179, 235)'
              },
              {
                offset: 0.5,
                color: 'rgb(5,151,235)'
              },
              {
                offset: 1,
                color: 'rgb(5,151,235)'
              }
            ])
          },
          {
            name: '公共安全',
            type: 'bar',
            stack: '广告',
            data: [0, 0, 0, 154],
            // color:'rgb(218,185,50)',
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(218, 211, 106)'
              },
              {
                offset: 0.5,
                color: 'rgb(218,185,50)'
              },
              {
                offset: 1,
                color: 'rgb(218,185,50)'
              }
            ])
          },
          {
            name: '无事件分类',
            stack: '广告', //设置分类，同一类合并，多个series数据成一个柱
            type: 'bar',
            // color:"rgb(179,111,230)",             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(205, 162, 230)'
              },
              {
                offset: 0.5,
                color: 'rgb(179,111,230)'
              },
              {
                offset: 1,
                color: 'rgb(179,111,230)'
              }
            ]),
            data: [0, 0, 0, 0, 145]
          }
        ]
      };


      myChart.setOption(option);
    }
  },
  components: {
    'title-h3': title
  }
  }
</script>
<style scoped>
  .eventCategory {
    width: 40%;
    height: 4.14rem;
  }

  .eventCategory .inner-wrap {
    /* height: 3.64rem; */
    height: 40vh;
    width: 100%;
    border-radius: 4px;
    padding-top: .08rem;
    overflow: hidden
  }

  .eventCategory .argument-warp {
    width: 97%;
    height: 3.54rem;
    margin: 0 auto;
    border-radius: 4px;
  }

  .w326 {
    width: 32.604%
  }

  #myChartEP {
    /* width: 40%; */
    /* margin: 0 auto; */
    /* height: 4rem; */
    /* padding-top: .215rem; */
    /* overflow: hidden */
  }

  #myChartEB {
    width: 50%;
    margin-left: 6%
  }
  .flex_box{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/emergencyManage/business.vue